export default function () {
    const competitionsWinnersContainer = document.querySelector('.blog-competition-winners');
    const competitionsPromosContainer = document.querySelector('.blog-competition-promos');

    if (competitionsWinnersContainer || competitionsPromosContainer) {
        fetch('https://blog.lotteryoffice.com.au/wp-json/wp/v2/competition?per_page=2&page=1')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (!data || data.length === 0) {
                    console.warn('No data found.');
                    return;
                }
                populateCompetitionSections(data);
            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    }

    function populateCompetitionSections(data) {
        data.forEach(item => {
            const { slug, acf, title } = item;
            const contentHTML = `
                <div class="competition-item">
                    <div>${acf.details}</div>
                </div>`;

            // Check the slug and append content to the appropriate container
            if (slug === 'competition-winners-2025' && competitionsWinnersContainer) {
                competitionsWinnersContainer.innerHTML = contentHTML;
            } else if (slug === 'special-promotional-terms-and-conditions-2025' && competitionsPromosContainer) {
                competitionsPromosContainer.innerHTML = contentHTML;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./assets/src/js/classes/competitions.js